import React from 'react'
import { Layout } from 'antd'

import { connect } from 'react-redux'
import classNames from 'classnames'
import TopBar from 'components/cleanui/layout/TopBar'
import Menu from 'components/cleanui/layout/Menu'

import styles from './style.module.scss'

const mapStateToProps = ({ settings }) => ({
  isContentMaxWidth: settings.isContentMaxWidth,
  isAppMaxWidth: settings.isAppMaxWidth,
  isGrayBackground: settings.isGrayBackground,
  isSquaredBorders: settings.isSquaredBorders,
  isCardShadow: settings.isCardShadow,
  isBorderless: settings.isBorderless,
  isTopbarFixed: settings.isTopbarFixed,
  isGrayTopbar: settings.isGrayTopbar,
})

const MainLayout = ({
  children,
  isContentMaxWidth,
  isAppMaxWidth,
  isGrayBackground,
  isSquaredBorders,
  isCardShadow,
  isBorderless,
  isTopbarFixed,
  isGrayTopbar,
}) => {
  return (
    <div className={classNames('officemail', { cui__layout__grayBackground: isGrayBackground })}>
      <Layout
        className={classNames({
          cui__layout__contentMaxWidth: isContentMaxWidth,
          cui__layout__appMaxWidth: isAppMaxWidth,
          cui__layout__grayBackground: isGrayBackground,
          cui__layout__squaredBorders: isSquaredBorders,
          cui__layout__cardsShadow: isCardShadow,
          cui__layout__borderless: isBorderless,
        })}
      >
        <Layout.Header
          className={classNames('cui__layout__header', styles.header, {
            cui__layout__fixedHeader: isTopbarFixed,
            cui__layout__headerGray: isGrayTopbar,
          })}
        >
          <TopBar />
        </Layout.Header>
        <React.Suspense fallback={<div>Loading...</div>} />
        {/* 루트 레이아웃(100vh)에서 헤더 64px 를 뺀 높이 — 100% 로 두면 body 에
            64px 짜리 바깥 스크롤이 생겨 페이지 스크롤과 이중이 된다 */}
        <Layout.Content style={{ height: 'calc(100% - 64px)', position: 'relative' }}>
          <Layout>
            <Menu menuType="admin" />
            <Layout>
              <Layout.Content style={{ height: '100%', position: 'relative' }}>
                <div className={classNames(styles.content)}>{children}</div>
              </Layout.Content>
            </Layout>
          </Layout>
        </Layout.Content>
      </Layout>
    </div>
  )
}

export default connect(mapStateToProps)(MainLayout)
